import axios from "vue-app/utils/axios";
import { DTOOnsite } from "vue-app/api/dto";
import { ONSITE_TYPE } from "vue-app/types/enums";

export const getCrossSellingOnsite = async () => {
  const { data } = await axios.get<DTOOnsite>("/onsite/smartCrossSelling");
  return data;
};

export const postOnsiteUpdateConfig = async (onsiteId: number, config: string) => {
  const { data } = await axios.post("/json/onsite/updateConfig", { onsite_id: onsiteId, config });
  return data;
};

export const postOnsiteDiscardChanges = async (onsiteId: number) => {
  const { data } = await axios.post("/json/onsite/discardChanges", { onsite_id: onsiteId });
  return data;
};

export const getOnsites = async (onsiteTypeId: number = 5) => {
  const { data } = await axios.post("/json/onsite/getOnsites", { onsite_type_id: onsiteTypeId });
  return data.data;
};

export const getOnsite = async (onsiteId: string) => {
  const { data } = await axios.post("/json/onsite/getOnsite", { onsite_id: onsiteId });
  return data.data;
};

export const getOnsiteTemplates = async () => {
  const { data } = await axios.get("/json/onsite/get_onsite_templates?onsite_type_id=5");
  return data.data;
};

export const addNewOnsite = async (onsiteType: ONSITE_TYPE, isReferAFriend: boolean) => {
  const { data } = await axios.post("/json/onsite/addNewOnsite", {
    onsite_type_id: onsiteType,
    onsite_for_refer_a_friend: isReferAFriend,
  });
  return data.data;
};

export const updateOnsiteName = async (onsiteId: number, name: string) => {
  const { data } = await axios.post("/json/onsite/updateName", {
    onsite_id: onsiteId,
    name,
  });
  return data;
};

export const deleteOnsite = async (onsiteId: number) => {
  const { data } = await axios.post("/json/external/deleteOnsite", {
    onsite_id: onsiteId,
  });
  return data;
};

export const duplicateOnsite = async (onsiteId: number) => {
  const { data } = await axios.post("/json/external/duplicateOnsite", {
    onsite_id: onsiteId,
  });
  return data;
};

export const deactivateOnsite = async (onsiteId: number) => {
  const { data } = await axios.post("/json/external/disableByOnsiteId", {
    onsite_id: onsiteId,
  });
  return data;
};

export const previewOnsite = async (onsiteId: number) => {
  const { data } = await axios.post("/json/external/previewByOnsiteId", {
    onsite_id: onsiteId,
  });

  return data.data;
};

export const publishOnsite = async (onsiteId: number) => {
  const { data } = await axios.post("/json/external/publishByOnsiteId", {
    onsite_id: onsiteId,
  });

  return data;
};

export const addNewOnsiteFromAssistant = async (onsiteType: ONSITE_TYPE, isReferAFriend: boolean, config: string) => {
  const { data } = await axios.post("/json/onsite/addNewOnsiteFromAssistant", {
    onsite_type_id: onsiteType,
    onsite_for_refer_a_friend: isReferAFriend,
    config,
  });

  return data;
};

export const putConfigToDynamoDb = async (onsiteId: number) => {
  const { data } = await axios.post("/json/external/putConfigToDynamoDb", {
    onsite_id: onsiteId,
  });

  return data;
};
